import { render, staticRenderFns } from "./wordDetailResult.vue?vue&type=template&id=2988cccd&scoped=true"
import script from "./wordDetailResult.vue?vue&type=script&lang=js"
export * from "./wordDetailResult.vue?vue&type=script&lang=js"
import style0 from "./wordDetailResult.vue?vue&type=style&index=0&id=2988cccd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988cccd",
  null
  
)

export default component.exports